import { createSelector } from 'reselect'
import { RootState } from '../types'
import { LoadingStateEnum } from '../../types'

export const getBusinessEntitiesLoadingState = (state: RootState): RootState['businessEntities']['loading'] =>
  state.businessEntities.loading

export const businessEntitiesLoading = createSelector(
  getBusinessEntitiesLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getBusinessEntitiesData = (state: RootState): RootState['businessEntities']['data'] =>
  state.businessEntities.data
export const getBusinessEntitiesError = (state: RootState): RootState['businessEntities']['error'] =>
  state.businessEntities.error

export const getBusinessEntityDetailsLoadingState = (
  state: RootState,
): RootState['businessEntities']['currentBusinessEntity']['loading'] =>
  state.businessEntities.currentBusinessEntity.loading

export const businessEntityDetailsLoading = createSelector(
  getBusinessEntityDetailsLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getBusinessEntityDetailsData = (
  state: RootState,
): RootState['businessEntities']['currentBusinessEntity']['data'] => state.businessEntities.currentBusinessEntity.data

export const getBusinessEntityDetailsError = (
  state: RootState,
): RootState['businessEntities']['currentBusinessEntity']['error'] => state.businessEntities.currentBusinessEntity.error

export const getUsersForAssignEntityLoadingState = (
  state: RootState,
): RootState['businessEntities']['usersForAssignEntity']['loading'] =>
  state.businessEntities.usersForAssignEntity.loading

export const usersForAssignEntityLoading = createSelector(
  getUsersForAssignEntityLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getUsersForAssignEntityData = (
  state: RootState,
): RootState['businessEntities']['usersForAssignEntity']['data'] => state.businessEntities.usersForAssignEntity.data
export const getUsersForAssignEntityError = (
  state: RootState,
): RootState['businessEntities']['usersForAssignEntity']['error'] => state.businessEntities.usersForAssignEntity.error

export const getEntitiesForAssignToUserLoadingState = (
  state: RootState,
): RootState['businessEntities']['entitiesForAssignToUser']['loading'] =>
  state.businessEntities.entitiesForAssignToUser.loading

export const entitiesForAssignToUserLoading = createSelector(
  getEntitiesForAssignToUserLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getEntitiesForAssignToUserData = (
  state: RootState,
): RootState['businessEntities']['entitiesForAssignToUser']['data'] =>
  state.businessEntities.entitiesForAssignToUser.data

export const getEntitiesForAssignToUserEnum = createSelector(getEntitiesForAssignToUserData, (entities) =>
  entities.items.map((entity) => ({ value: entity.id, label: entity.name })),
)
export const getEntitiesForAssignToUserError = (
  state: RootState,
): RootState['businessEntities']['entitiesForAssignToUser']['error'] =>
  state.businessEntities.entitiesForAssignToUser.error

export const createBusinessEntityLoadingState = (
  state: RootState,
): RootState['businessEntities']['createBusinessEntity']['loading'] =>
  state.businessEntities.createBusinessEntity.loading

export const createBusinessEntityLoading = createSelector(
  createBusinessEntityLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const createBusinessEntityData = (
  state: RootState,
): RootState['businessEntities']['createBusinessEntity']['data'] => state.businessEntities.createBusinessEntity.data
export const createBusinessEntityError = (
  state: RootState,
): RootState['businessEntities']['createBusinessEntity']['error'] => state.businessEntities.createBusinessEntity.error
